import { toString } from "../../../lib/utils/string";
export const promptAtom = {
  id: 'uicore:prompt',
  name: '弹出文字输入框',
  category: 'UI交互',
  paramsSchema: {
    type: 'object',
    fields: [{
      id: 'message',
      type: 'string',
      title: '提示消息',
      default: '请输入一些东西：',
      ui: {
        settings: {
          multipleLine: true
        }
      }
    }, {
      id: 'defaultValue',
      type: 'string',
      title: '默认值'
    }, {
      id: 'password',
      type: 'boolean',
      title: '密码模式'
    }, {
      id: 'allowEmpty',
      type: 'boolean',
      title: '允许空字符串'
    }, {
      id: 'abortIfRejected',
      type: 'boolean',
      title: '选择了“取消”就终止流程（否则会使用默认值）',
      default: true
    }]
  },
  returnValue: () => ({
    type: 'string',
    description: '用户输入的文本'
  }),
  execute: async (ctx, params) => {
    const uc = ctx.uc;
    while (true) {
      const answer = await uc.$prompt({
        message: toString(params.message),
        defaultValue: toString(params.defaultValue),
        password: !!params.password
      });
      if (answer === null) {
        if (params.abortIfRejected) ctx.abort();
        return params.defaultValue;
      }
      if (answer === '' && !params.allowEmpty) continue;
      return answer;
    }
  }
};